import { render, staticRenderFns } from "./DepositoShowData.vue?vue&type=template&id=1c4f2c44&scoped=true"
import script from "./DepositoShowData.vue?vue&type=script&lang=js"
export * from "./DepositoShowData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4f2c44",
  null
  
)

export default component.exports